import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,DownloadFile } from './Function';
import { Row,Col,Card,Form,InputGroup,Button,Placeholder,Spinner } from 'react-bootstrap';
const NewsLettersArchive = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const[NewsLetters,setNewsLetters]=useState([]);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        fetchNewsLetter(true);
        // eslint-disable-next-line
    },[])
    const fetchNewsLetter = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);
            setNewsLetters([]);
        }
        try 
        {
            var keywordText = keyword || 'none';
            const { startDate, endDate } = setDateRange(year, month, 0, 1, 0);
            const currentRows = isReset ? 0 : Rows;
            const callApi = global.config.API_URL + `newsLetters/list/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('fetchNewsLetter : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.n_id + "/nNewsletter")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.n_id + "/nNewsletterHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].nNewsletter = el.upp;
                        result[i].nNewsletterHi = el.upph;                            
                    });
                    setNewsLetters(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                    setRows(currentRows + 30);           
                    setLoadMore(true);
                }).catch(error => {
                    console.error('NewsLetters File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setLoadMore(false);
            }
            if( global.config.IsPrint === true ) { console.info('NewsLetterArchives : Result',result); }
        } catch (error) 
        {
            console.error('NewsLetterArchives : Error', error.message);
        }
        finally 
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        e.preventDefault();
        if (!keyword && year === 0 && month === 0) 
        {
            alert(t('FilterAlert'));
            return;
        }
        fetchNewsLetter(true);
    };
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {t('Newsletters')}
            </Card.Header>
            <Card.Body>
                <Card className='mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <InputGroup>
                                        <Form.Select onChange={YearChange} value={year}>
                                            <option value={0}>{t('FilterYear')}</option>
                                            {setYearList(0, 1).map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Select onChange={MonthChange} value={month}>
                                            <option value={0}>{t('FilterMonth')}</option>
                                            {setMonthList().map(({ value, label }) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                    </InputGroup>                                    
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                {isLoading ? (
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-4 g-3'>
                {[...Array(10)].map((_,index)=>(
                    <Col key={index}>
                        <Card className="bg-primary text-white text-center" data-aos="flip-up" data-aos-duration="1000">
                            <Card.Img src={global.config.uploadPath+'1131615306.png'} />
                            <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center'>
                                <Card.Title><Placeholder xs={10} /></Card.Title>
                                <Button className='btn btn-light w-50'><Placeholder xs={12} /></Button>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                ))}
                </Row>
                ) : (
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-4 g-3'>
                {NewsLetters.map((n,index)=>(
                    <Col key={index}>
                        <Card className="bg-primary text-white text-center" data-aos="flip-up" data-aos-duration="1000">
                            <Card.Img src={global.config.uploadPath+'1131615306.png'} />
                            <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center'>
                                <Card.Title>{appLanguage === 'hi' ? (n.n_display_en === "1" ? n.n_name_hi || '' : n.n_name_hi || n.n_name) : n.n_name}</Card.Title>
                                <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,n.nNewsletter,n.nNewsletterHi)}} />
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                ))}
                </Row>
                )}
                {isLoadMore &&
                <div className='text-center p-3'>
                    <Button className='btn btn-info mt-3' onClick={() => fetchNewsLetter(false)} disabled={isLoading}>
                        {isLoading ? (
                        <React.Fragment>
                            <Spinner animation="grow" variant="light" size="sm" />
                            <Spinner animation="grow" variant="danger" size="sm" />
                            <span className='ms-2'>{t('PleaseWait')}</span>
                        </React.Fragment>
                        ) : t('LoadMore')}
                    </Button>
                </div>}
            </Card.Body>
        </Card>
    );
}
export default NewsLettersArchive;